module.exports = "<div>\n    <router-outlet></router-outlet>\n</div>\n"